import { LogOutIcon } from '@/icons';
import { filterRoutesByRole, findMenuKeys } from '@/utils';
import { Flex, Image } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Link, useLocation } from 'react-router';
import type { TUserRoles } from '../../app/app.constants';
import { useAppDispatch } from '../../app/app.store';
import { userLoggedOut } from '../../app/features/auth/auth.slice';
import IMAGES from '../../assets/images';
import CustomNavigationItem from '../../components/CustomNavItem';
import useAuth from '../../hooks/useAuth';
import useModuleStatus from '../../hooks/useModuleStatus';
import { cn } from '../../lib/cn';
import { APP_ROUTES } from '../../routes/routes';

const Sidebar = () => {
  const { theme, role } = useAuth();
  const { isEnabled } = useModuleStatus();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const filteredMenu = filterRoutesByRole(
    APP_ROUTES,
    role as TUserRoles,
    isEnabled,
    true,
  );

  const { selectedKey, openKeys } = findMenuKeys(
    filteredMenu,
    location.pathname,
  );

  const handleLogout = () => {
    dispatch(userLoggedOut());
  };

  return (
    <>
      <div className="hidden md:block">
        <Sider
          width={160}
          theme={theme}
          trigger={null}
          collapsed={false}
          collapsible={true}
          className="custom-sidebar"
        >
          <Link to="/admin/employee/dashboard">
            <Flex align="center" className={cn('h-20 mb-4 mx-[30px] mt-2.5')}>
              <Image preview={false} src={IMAGES.hrx} alt="HRX" />
            </Flex>
          </Link>

          {/* Sidebar Menus */}
          <div
            className={cn(
              'py-4 px-2 mx-[30px] relative h-[calc(100vh_-_140px)]',
              'dark:bg-theme-slate-800 border dark:border-theme-gray-700 rounded-xl',
            )}
          >
            <div className="h-full w-full overflow-y-auto pb-[94px] space-y-4 hide-scrollbar">
              {filteredMenu?.map((menu, idx) => {
                const Icon = menu?.icon;
                const path = menu?.element
                  ? menu.path
                  : menu?.children?.[0]?.path;
                const isActive = openKeys?.length
                  ? openKeys?.includes(menu?.path)
                  : selectedKey === menu?.path;

                return (
                  <CustomNavigationItem
                    key={idx}
                    path={path}
                    isActive={isActive}
                    label={menu?.label as string}
                    classNames={{ button: '!text-xs' }}
                    icon={
                      Icon ? (
                        <Icon className="text-xl" strokeWidth={1.6} />
                      ) : null
                    }
                  />
                );
              })}
            </div>

            <div className="absolute left-2 right-2 bottom-4">
              <CustomNavigationItem
                label="Log out"
                classNames={{ button: '!text-xs' }}
                icon={<LogOutIcon className="text-xl" strokeWidth={1.6} />}
                onClick={handleLogout}
              />
            </div>
          </div>
        </Sider>
      </div>
    </>
  );
};

export default Sidebar;
